import { Grid, Typography } from "@mui/material";
import theme from "../theme";
import VoucherBill from "./VoucherBill";
import CsSelectVoucher from "./CsSelectVoucher";
import { useEffect, useState } from "react";
import axios from "axios";
import { APIConstants } from "../constants/ApiConstants";
import { useAppSelector } from "../redux/hooks";
import { useDispatch } from "react-redux";
import { salesActions } from "../redux/slices/SalesSlice";
import Loader from "../components/ui/Loader";
import salesImage from "../assets/sales.png";
import MemberDetailsHeaderNew from "../components/member/MemberDetailsHeaderNew";
import { usePermissionGetter } from "../Hooks/Permissions/userPermissionGetter";
import { permissionsConstants } from "../constants/AppConstants";

const Sales = () => {
  const { getUserPermission: getSalesPermission } = usePermissionGetter(
    permissionsConstants.sale_of_voucher,
    permissionsConstants.sales
  );
  const dispatch = useDispatch();
  const [salesData, setSalesData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );
  const selectedVouchers = salesData.filter(
    (salesData: { amount: number }) => salesData.amount > 0
  );
  const loyaltyPoints = useAppSelector(
    (state: any) => state.persistReducers.pointsSlice.points
  );
  const mapResponse = (sales: any) => {
    const uniqueTitles = new Set();
    const uniqueSales = sales.reduce((result: any[], singleSale: any) => {
      const title = singleSale.offer_text ? singleSale.offer_text : "No title";
      if (!uniqueTitles.has(title)) {
        uniqueTitles.add(title);
        result.push({
          id: singleSale.id,
          voucherAmount: 0,
          limitVoucher: singleSale.quantity_limit,
          price: singleSale.price ? singleSale.price : 0,
          amount: 0,
          title: title,
          image: singleSale.standard_images[0]
            ? singleSale.standard_images[0]
            : salesImage,
        });
      }

      return result;
    }, []);

    dispatch(salesActions.updateSalesState(uniqueSales));
    setSalesData(uniqueSales);
    setLoading(false);
  };

  const getSalesInfo = async () => {
    let salesDetails;
    try {
      setLoading(true);
      salesDetails = await axios.get(
        process.env.REACT_APP_API_URL + APIConstants.eVouchers
      );
      const sales = salesDetails.data.data.evouchers;
      mapResponse(sales);
    } catch (error: any) {
      if (error?.response?.data?.data?.evouchers?.length > 0)
        mapResponse(error?.response?.data?.data?.evouchers);
      setLoading(false);
    }
  };

  const resetVoucherBill = () => {
    setSalesData((prev: any) => {
      return prev.map((voucher: any) => {
        return { ...voucher, amount: 0 };
      });
    });
  };

  useEffect(() => {
    getSalesInfo();
  }, []);

  return (
    <Grid display={"flex"} justifyContent={"space-evenly"}>
      <Grid
        display={"flex"}
        justifyContent={"center"}
        alignItems={"start"}
        height={"85vh"}
      >
        {getSalesPermission("read") && (
          <MemberDetailsHeaderNew
            pointsValidityData={memberDetails && memberDetails.expirySchedules}
            expiryDate={memberDetails && memberDetails.expiry_points_date}
            nextSlab={memberDetails && memberDetails.nextSlab}
            expiryPoints={memberDetails && memberDetails.expiry_points}
            email={memberDetails && memberDetails.email}
            memberSince={memberDetails && memberDetails.join_date}
            slabExpiryDate={memberDetails && memberDetails.slabExpiryDate}
            memberName={
              memberDetails && memberDetails.first_name
                ? `${memberDetails.first_name} ${memberDetails.last_name}`
                : "-"
            }
            memberTier={memberDetails && memberDetails.currentSlab}
            loyaltyNo={memberDetails && memberDetails.loyaltyId}
            status={
              memberDetails && memberDetails.customer_status
                ? memberDetails.customer_status
                : "-"
            }
            loyaltyPoints={
              loyaltyPoints > 0 ? loyaltyPoints : memberDetails.loyaltyPoints
            }
            carpark={"0"}
            min_purchase_value_required={
              memberDetails && memberDetails.min_purchase_value_required
            }
            gap_to_upgrade={memberDetails && memberDetails.gap_to_upgrade}
            upgrade_by={memberDetails && memberDetails.upgrade_by}
            gap_to_renew={memberDetails && memberDetails.gap_to_renew}
            renew_by={memberDetails && memberDetails.renew_by}
            currentSlab={memberDetails && memberDetails.currentSlab}
            yuu_status={memberDetails && memberDetails?.yuu_linking_status}
            show_yuu ={false}
          />
        )}
      </Grid>
      {getSalesPermission("read") && (
        <Grid
          width={"35%"}
          maxHeight={"85vh"}
          sx={{ background: theme.color?.background }}
          borderRadius={"16px"}
          px={3}
          py={4}
          overflow={"auto"}
        >
          <Typography
            variant="h5"
            style={{
              borderBottom: theme.border?.smallGrey,
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: theme.font?.fontWeight.thick,
              fontSize: theme.font?.fontSize.large,
            }}
            pb={2}
            mb={2}
          >
            Select Voucher
          </Typography>
          {!loading ? (
            salesData.map((saleData: any, index: any) => (
              <CsSelectVoucher
                key={index}
                count={saleData.amount}
                limitVoucher={saleData.limitVoucher}
                imageSrc={saleData.image}
                voucherName={saleData.title}
                price={saleData.price}
                onVoucherCountChange={(newCount: number) => {
                  const updatedSalesData = salesData.map((data: any) =>
                    data.title === saleData.title
                      ? { ...data, amount: newCount }
                      : data
                  );
                  setSalesData(updatedSalesData);
                }}
              />
            ))
          ) : (
            <Grid display={"flex"} justifyContent={"center"} mt={2}>
              <Loader />
            </Grid>
          )}
        </Grid>
      )}
      <Grid
        width={"35%"}
        height={"85vh"}
        sx={{ background: theme.color?.background }}
        borderRadius={"16px"}
        py={4}
        px={3}
      >
        <VoucherBill
          reset={resetVoucherBill}
          vouchers={selectedVouchers}
          onVoucherCountChange={function (
            voucherIndex: number,
            newCount: number
          ): void {
            throw new Error("Function not implemented.");
          }}
        ></VoucherBill>
      </Grid>
    </Grid>
  );
};

export default Sales;
